// Helpers for meter readings stored as DECIMAL(15,3) (docs/fix-readings-data-type-frontend.md): 12 integer digits, 3 decimals, never rounded.

const READING_PATTERN = /^\d{1,12}(\.\d{1,3})?$/

export const READING_FORMAT_MESSAGE = 'Enter a non-negative number with at most 12 digits before and 3 after the decimal point.'

// Trims the typed reading, turns a comma separator into '.', and drops a trailing '.'; keeps the text otherwise untouched. 2026-10-25
export function normalizeReading(value) {
  if (value === null || value === undefined) return ''
  return String(value).trim().replace(',', '.').replace(/\.$/, '')
}

// Returns an error string if the reading is not a valid 12.3 decimal, otherwise ''. 2026-10-25
export function readingFormatError(value) {
  const text = normalizeReading(value)
  if (text === '') return 'Enter a reading.'
  return READING_PATTERN.test(text) ? '' : READING_FORMAT_MESSAGE
}

// Consumption (current - previous) rounded to 3 decimals to avoid float noise like 0.30000000000000004. 2026-10-25
export function consumption(current, previous) {
  return Math.round((Number(current || 0) - Number(previous || 0)) * 1000) / 1000
}



// WEBPACK FOOTER //
// ./src/utils/readings.js